import React from "react"

import { Control } from "react-hook-form"

import RatingSelect from "./RatingSelect"
import SectionHeader from "./SectionHeader"

interface DeliverySuccessSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  calculateResult: () => void
}

const deliverySuccessOptions = [
  { value: "Up to Standard", label: "Up to Standard (100% success)" },
  { value: "Satisfactory", label: "Satisfactory (90-99% success)" },
  { value: "Needs Improvement", label: "Needs Improvement (75-89% success)" },
  { value: "Failed Protocol", label: "Failed Protocol (Below 75%)" },
]

const DeliverySuccessSection: React.FC<DeliverySuccessSectionProps> = ({
  control,
  calculateResult,
}) => {
  return (
    <div className="space-y-4">
      <SectionHeader title="Delivery Success Rate" />

      <RatingSelect
        control={control}
        name="deliverySuccessRate"
        label="Delivery Success Score"
        options={deliverySuccessOptions}
        calculateResult={calculateResult}
      />
    </div>
  )
}

export default DeliverySuccessSection
